import React, {ReactElement, ReactNode} from 'react';
import {fonts} from '@fo/shared/styles/variables';
import Paragraph from '@fo/designSystem/Text/Paragraph/Paragraph';
import CheckpointItem, {Icon, IconColour} from './CheckpointItem';

interface Props {
  className?: string;
  icon: Icon;
  iconColour?: IconColour;
  itemsClassName?: string;
  listItems: string[] | ReactNode[];
}

function CheckpointsContainer({className, icon, iconColour, itemsClassName, listItems}: Props): ReactElement {
  return (
    <div className={`checkpoints ${className || ''}`.trim()}>
      {listItems.map((content, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <CheckpointItem key={i.toString()} icon={icon} iconColour={iconColour} className={itemsClassName}>
          <Paragraph alignment={fonts.alignment.LEFT}>{content}</Paragraph>
        </CheckpointItem>
      ))}
    </div>
  );
}

export default CheckpointsContainer;
